const webshops = {
    'clients.webshops.add': 'Add webshop',
    'clients.webshops.edit': 'Edit webshop',

    'clients.webshops.api_settings': 'API settings',
    'clients.webshops.host': 'Host',
    'clients.webshops.username': 'User name',
    'clients.webshops.password': 'Password / API key',
    'clients.webshops.consumer_key': 'Consumer Key',
    'clients.webshops.consumer_secret': 'Consumer Secret',
    'clients.webshops.sync_settings': 'Synchronisation settings',
    'clients.webshops.compare_prices': 'Compare prices',
    'clients.webshops.infobar.compare_prices': 'Price comparison will primary be on the EAN code of the products. If there is no match the secondary comparison on the unique code will be applied.',
};

export default webshops;
